import styled from 'styled-components';

export const Content = styled.div``;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s4);
`;

/*
 * The design's `.repeat-item` — one numbered block per question.
 *
 * What it replaces: two side-by-side panels, each headed by a centred `#eef1f6`
 * pill at 14px in `#8a93ac`, with the saved questions listed in `#f7f8fc`
 * cards holding a peach `#f6e6e0` type pill and two 40px circular icon
 * buttons on `#eef1f6` and `#fdf0ef` grounds. Seven colours, none of them in
 * the palette, for one repeated object.
 */
export const RepeatItem = styled.div`
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  padding: var(--s4);
  background: var(--surface-alt);

  /* The composer, and whichever saved block it is currently holding. */
  &.composer {
    background: var(--surface);
    border-style: dashed;
    border-color: var(--line-strong);
  }

  &.editing {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--primary-soft);
  }
`;

export const RepeatHead = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  margin-bottom: var(--s3);
`;

export const RepeatN = styled.span`
  font-family: var(--font-mono);
  font-size: var(--fs-micro);
  color: var(--text-faint);
  background: var(--surface);
  border: 1px solid var(--line);
  padding: 2px 7px;
  border-radius: var(--r-sm);
`;

/** The question type, as a name rather than as a coloured pill. */
export const RepeatType = styled.span`
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  color: var(--text);

  &.new {
    color: var(--text-faint);
    font-weight: var(--fw-medium);
  }
`;

export const RepeatActions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--s1);
`;

/** The saved question, EN and AR on one baseline — the same grid as the pair. */
export const QuestionPair = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--s4);
`;

export const QuestionText = styled.p`
  font-family: var(--font-content);
  font-size: var(--fs-body);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  color: var(--text);

  &[dir='rtl'] {
    font-family: var(--font-ar);
    text-align: right;
  }
`;

/** The design's `.subhead`. */
export const SubHead = styled.div`
  font-size: var(--fs-th);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-faint);
  margin: var(--s4) 0 var(--s3);
`;

export const Choices = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
`;

export const Choice = styled.li`
  font-family: var(--font-content);
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  color: var(--text-muted);
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-pill);
  padding: 3px 9px;
`;

/*
 * One editable choice: the bilingual pair, with its delete beside it rather
 * than a 35px circle absolutely positioned into the row's top-right corner.
 */
export const ChoiceRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--s2);
  margin-bottom: var(--s3);

  > *:first-child {
    flex: 1;
    min-width: 0;
  }
`;

/** Pushed down so the icon lines up with the controls, not with their labels. */
export const ChoiceAction = styled.div`
  display: flex;
  align-items: center;
  padding-top: 22px;
`;

export const Field = styled.div`
  margin-bottom: var(--s4);
  max-width: 320px;
`;
